<template>
    <div :class="{'full': hasDescription, 'min': !hasDescription}">
        <p v-if="hasDescription" >{{description}}</p>
        <div :class="{'price': hasPrice}">
            <p 
                v-if="hasPrice"
            >
                {{ formatPrice }} &euro;
            </p>
            <a
                :href="url"
                :title="title"
                class="btn"
            >
                {{ locale_btn | trans }}
            </a>
        </div>
    </div>
</template>

<script>
import numeral from 'numeral';
import { isNil } from 'ramda';

numeral.register('locale', 'es', {
    delimiters: {
        thousands: '.',
        decimal: ','
    },
    abbreviations: {
        thousand: 'k',
        million: 'm',
        billion: 'b',
        trillion: 't'
    },
});
numeral.locale('es');

export default {
    name: "full-description",
    props: {
        type: {
            type: String,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        description: {
            type: String,
            default: ''
        },
        url: {
            type: String,
            required: true
        },
        price: {
            type: String,
            default: ''
        }
    },
    computed: {
        formatPrice() {
            const number = Number(this.price);
            return numeral(number).format('0.0[,]00');
        },
        hasPrice() {
            return this.price !== '';
        },
        hasDescription() {
            return this.description !== '';
        },
        locale_btn() {
            return `whattodo.btn_${this.type}`;
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/FullDescription.vue